import { Avatar, AvatarProps, styled } from "@mui/material";
import { memo } from "react";

const CustomAvatarStyled = styled(Avatar)<AvatarProps>(() => ({
  borderRadius: '42%',
}));

const CustomAvatar: React.FC<AvatarProps> = (props) => {
  return (
    <CustomAvatarStyled {...props}
      slotProps={{
        img: {
          loading: 'lazy',
        }
      }}
    />
  )
}

export default memo(CustomAvatar);
